<template>
  <div id='app'>
    <form @submit.prevent='login'>
      <input v-model='loginuser.uname' placeholder='username'>
      <input v-model='loginuser.pwd' placeholder='password' type='password'>
      <input id="submit" type='submit' value='Login' />
      <span id="loginerr">{{ loginuser.message }}</span>
    </form>

    &nbsp;
    <br/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Login',
  computed: {
    ...mapGetters(['loginuser', 'isLoggedIn'])
  },
  methods: {
    login () {
      this.$store.dispatch('login', this.loginuser)
      setTimeout(() => this.isLoggedIn ? this.$router.push({ name: 'Directory' }) : false, 1000)
    }
  }
}
</script>
<style scoped>
* {
  box-sizing: border-box;
}

#app {
  width: 50%;
  /* border: 1px; */
  /* border: 5px solid; */
  height: 150px;
  margin:0 auto;
}

form, input  {
  display: block;
  width: 100%;
  padding: 10px;
  margin:0 auto;
}

#submit {
  width: 25%;
  background: darkblue;
  color: white;
  font-weight: bold;
}

span#loginerr {
  color: red;
  font-weight: bold;
}
</style>
